import { Box, Link } from '@chakra-ui/react';
import CardGrid from '@msr/components/Card/CardGrid';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';
import NextLink from 'next/link';
import React from 'react';

const TamilThembu = ({ sectionContent, lang, section }) => {
  return (
    <Box
      bgColor={'blue.400'}
      p={{ base: '60px 0px 20px 0px', lg: '60px 20px' }}
      id="tamilthembu"
    >
      <Box w={{base:'80%', md: lang == 'ta' ? '670px' : '100%'}} m="0 auto">
      <MsrSectionTitle
        pt="0"
        mt="0"
        titleObj={sectionContent[0]}
        fontFamily={lang == 'ta' ? 'MuktaMalar' : 'FedraSerifAStdBook'}
        fontWeight={lang == 'ta' ? '600' : '500'}
        fontSize={'24px'}
        color="#FFF7E9"
      />
      </Box>

      <Box
        backgroundImage={section?.styleConfig?.bgImage?.url}
        bgSize={{ base: 'contain', sm: 'cover', xl: 'contain' }}
        bgPos={{ base: 'top', lg: 'center', '2xl': 'center' }}
        bgRepeat="repeat"
        width="100%"
        position="relative"
        display="flex"
        flexDir="column"
        justifyContent="center"
        marginTop={{ base: '20px', sm: '20px', lg: '50px' }}
        className='visual_card'
      >
        <CardGrid
          sectionContent={sectionContent[1]}
          title={{ fontSize: '22px', color: '#FFA735' }}
          sessions={{ fontSize: '18px', color: 'yellow.100' }}
          desc={{ color: 'blue.200', pt: { base: '10px', md: '25px' } }}
          pageType="tamilthembu"
          lang={lang}
          fontWeights="350"
        />
        {sectionContent[2]?._modelApiKey === 'simple_button' && (
          <Box
            display="flex"
            mt={{ base: '10px', lg: '20px' }}
            mb={{ base: '20px', lg: '40px' }}
            justifyContent="center"
          >
            <Box display="flex" justifyContent="center">
              <NextLink
                href={sectionContent[2]?.linkUrl}
                passHref
                legacyBehavior
              >
                <Link
                  className="orange-button"
                  m="auto"
                  display="block"
                  fontWeight={'500'}
                  fontFamily={'FedraSansStd-medium'}
                  fontSize={'16px'}
                  bgColor="yellow.100"
                  h={'auto'}
                  minH="50px"
                  textAlign="center"
                  padding={'18px 20px'}
                  borderRadius="5px"
                  color="black"
                  textDecoration="none"
                  width={'151px'}
                  height={'56px'}
                  _hover={{
                    bg: 'fulvous',
                  }}
                  target={'_blank'}
                >
                  {sectionContent[2]?.buttonText}
                </Link>
              </NextLink>
            </Box>
          </Box>
        )}
      </Box>
      <style global jsx>
        {`
          @media (max-width: 767px) {
            #tamilthembu h2 {
              font-size: 24px;
          }
            .visual_card img {
              width: 287px !important;
              height: 184px !important;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default TamilThembu;
